export const notifications = (state) => {
  return state.notifications
}
